<template>
  <div class="card-body py-4 text-center">
    <audio controls>
      <source :src="item.links.download_url" />
    </audio>
    <div>
      <a
        :href="item.links.download_url"
        v-if="canDownload"
        class="btn btn-primary mt-3"
        download
        >Download</a
      >
    </div>
  </div>
</template>

<script>
import CanDownloadMixin from "@/src/components/viewer/can_download_mixin.vue";

export default {
  mixins: [CanDownloadMixin],
  props: {
    item: Object,
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
@import "../../../packs/application.scss";
</style>
